// react
import React, { Fragment, useEffect, useState } from 'react';
// styles
import styles from './index.module.scss';
import { useNavigate } from 'react-router-dom';
// get role
import { getRoleService } from '../../services/adminService';
import Cookies from 'js-cookie';
// redux
/***************************************************************************/
/* Name : NavHeader React Component */
/***************************************************************************/
const NavHeader = React.memo(({ title, mode }) => {
  const navigate = useNavigate();
  const [role, setRole] = useState('NOT');
  const [id, setId] = useState(Cookies.get('id'));
  const [nationalID, setNationalID] = useState(Cookies.get('nationalID'));
  /***************************************************************************/
  /* Name : backwardHandler */
  /* Description : backwardHandler */
  /***************************************************************************/
  const backwardHandler = () => {
    navigate(-1);
  };
  /***************************************************************************/
  /* Name : logout */
  /* Description : logout */
  /***************************************************************************/
  const logout = () => {
    Cookies.remove('id');
    Cookies.remove('seatNo');
    Cookies.remove('nationalID');
    navigate('/');
  };
  useEffect(() => {
    (async () => {
      // calling load
      const { role } = await getRoleService();
      if (role !== undefined) {
        setRole(role);
      }
    })();
  }, []);

  return (
    <Fragment>
      <div className={styles['container']}>
        <div>{title}</div>
        <div className={styles['links']}>
          {((!!id && role === 'NOT') || nationalID) && (
            <a onClick={logout}>تسجيل الخروج |</a>
          )}
          {!!id && <a onClick={backwardHandler}>رجوع</a>}
        </div>
      </div>
    </Fragment>
  );
});

export { NavHeader };
